import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Added for navigation
import '../../assets/styles/Warehousing.css';

function Warehousing() {
  return (
    <>
      <Helmet>
        <title>RFF Cargo: Warehousing</title>
        <meta name="description" content="Flexible storage solutions for your logistics needs." />
      </Helmet>
      <section className="warehousing-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src="/assets/images/slider-loading-image1.jpg"
                className="warehousing-image img-fluid rounded"
                alt="Warehousing Services"
              />
            </div>
            <div className="col-md-6">
              <h2 className="service-title fw-bold mb-4">Warehousing Services</h2>
              <p className="service-description">
                Our secure and flexible warehousing solutions support your logistics operations with state-of-the-art facilities. From short-term storage to long-term inventory management, RFF Cargo provides tailored services to optimize your supply chain, ensuring safety, accessibility, and efficiency.
              </p>
              <Link to="/contact" className="btn btn-contact-us mt-3">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Warehousing;